export function formatVoiceElapsed(totalSeconds: number) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return `${minutes}:${seconds.toString().padStart(2, "0")}`;
}

export function VoiceActivityBars({ active }: { active: boolean }) {
  const heights = [10, 18, 13, 22, 15, 20, 11, 16, 19, 12];

  return (
    <div className="flex h-6 items-center gap-0.5 overflow-hidden" aria-hidden="true">
      {heights.map((height, index) => (
        <span
          key={`${height}-${index}`}
          className={`w-0.5 rounded-full bg-red-500/80 ${active ? "animate-pulse" : "opacity-50"}`}
          style={{ height, animationDelay: `${index * 75}ms` }}
        />
      ))}
    </div>
  );
}
